import React from "react"
import { useStore } from "../../teafuljs/store"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import DialogContent from "@material-ui/core/DialogContent"
import Divider from "@material-ui/core/Divider"
import PlayCircleFilled from "@material-ui/icons/PlayCircleFilled"
import KeyPassages from "./../../data/newKeyPassages.json"
import YWAMValues from "./../../data/YWAMValues.json"
import YWAMLogo from "./../../../static/images/YWAMLogo.png"
import GetSegment from "../../scripts/NavigateToSegment"
import scrollToElement from "scroll-to-element"
import { getTranslation } from "../../scripts/getTranslation"
import getVersionVerse from "../../scripts/getVersionVerse"
import DStarterContent from "../DStarter/DStarterContent"

import { makeStyles } from "@material-ui/core/styles"

const ValuesArray = Object.values(YWAMValues)

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(2),
    fontSize: "small",
    color: "white",
  },
  definition: {
    fontWeight: "bold",
  },
  dialogRef: {
    color: "grey",
    fontSize: "80%",
    textAlign: "center",
    marginBottom: "-15px",
  },
  dialogHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "-10px",
  },
  logo: {
    height: "30px",
    width: "auto",
  },
  SVicons: {
    height: "50px",
    width: "50px",
    marginRight: "5px",
    marginBottom: "5px",
  },
  dialogTitle: {
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "space-between",
  },
  navButtons: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    textAlign: "center",
  },
  icon: {
    backgroundColor: "white",
    color: "#19857b",
    borderRadius: "25px",
    fontSize: "30px",
  },
  nextNum: {
    fontSize: "50%",
    color: "grey",
    margin: 0,
    textAlign: "center",
    lineHeight: "120%",
  },
  nextTitle: {
    fontSize: "40%",
    color: "grey",
    margin: 0,
  },
  nextRef: {
    fontSize: "45%",
    color: "grey",
    margin: 0,
  },
  link: {
    position: "relative",
    width: "40%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  category: {
    position: "relative",
    width: "100%",
    color: "grey",
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: "80%",
    textAlign: "center",
  },
  title: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 3,
  },
  closeButtonHolder: {
    margin: 0,
    padding: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  description: {
    fontSize: "80%",
    textAlign: "center",
    margin: 3,
  },
  refTitle: {
    fontWeight: "bold",
    textAlign: "center",
    margin: 0,
  },
  fullRef: {
    fontSize: "50%",
    color: "grey",
    textAlign: "center",
  },
  dStarter: {
    marginBottom: 20,
  },
}))

const ValuesDialog = ({ valuesDialog, newValuesDialog, onClose }) => {
  const translations = useStore.translations()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const versification = useStore.versification()[0]
  const [history, setHistory] = useStore.history()
  const [refID, setRefID] = useStore.refID()
  const [searchID, setSearchID] = useStore.searchID()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
  const classes = useStyles()
  const { content } = valuesDialog
  console.log("values content", content)
  const { standardRef, fullRef, id, description, title } = content
  const dStarter =
    language === "ENG"
      ? getTranslation(
          translations,
          language,
          "Values",
          `${id}-dStarter`
        )
      : null
  console.log(dStarter)
  const currentIndex = ValuesArray.findIndex(v => v.id === id)
  const isStandardVersification =
    AvailableContent.content[language].versions[version]
      .versification === "standard"

  const getNewValue = num => {
    const ValuePassage = ValuesArray[currentIndex + num]

    const book = ValuePassage.fullRef.split(" ")[0]
    const isAvailable =
      AvailableContent.content[language][version][book] &&
      AvailableContent.content[language][version][book]
        .segments.length > 1
        ? true
        : false
    if (isAvailable) {
      return ValuePassage
    } else {
      return false
    }
  }

  const availablePassage = direction => {
    let i = direction === "prev" ? -1 : 1
    while (!getNewValue(i)) {
      if (direction === "prev") {
        i = i - 1
      } else {
        i = i + 1
      }
    }
    if (getNewValue(i) === "none") {
      return false
    } else {
      return getNewValue(i)
    }
  }

  function search(RefID) {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
      ...history,
    ])
    const refInfo = RefID.split("-")
    const segment = GetSegment(
      refInfo[0],
      parseInt(refInfo[1]),
      parseInt(refInfo[2])
    )
    if (currentSegmentID === segment) {
      newValuesDialog({ open: false, content: {} })
      console.log("same page navigation: did it work?")
      samePageNavigation(`ref-${RefID}`)
    } else {
      newValuesDialog({ open: false, content: {} })
      console.log("Did it navigate?")
      setCurrentSegmentID(segment)
      setRefID(RefID)
    }
  }

  function samePageNavigation(id) {
    const element = document.querySelectorAll(`[verseref=${id}]`)[0]
    scrollToElement(element, {
      offset: -65,
      ease: "inOutCube",
      duration: 1500,
    })
    console.log("same page navigation")
    setSearchID("")
  }

  return (
    <Dialog
      maxWidth="lg"
      open={valuesDialog.open}
      onClose={() => newValuesDialog({ open: false, content: {} })}
    >
      <DialogTitle>
        <div className={classes.dialogHeader}>
          <img src={YWAMLogo} className={classes.logo} alt="YWAM Logo" />
          <p
            className={classes.dialogRef}
            style={language === "ARB" ? { direction: "rtl" } : {}}
          >
            {getTranslation(
              translations,
              language,
              "Values",
              `${id.split("-")[0]}-T`
            )}
          </p>
          <div className={classes.closeButtonHolder}>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <p
          className={classes.title}
          style={language === "ARB" ? { direction: "rtl" } : {}}
        >
          {+id.split("-")[1]}.{" "}
          {getTranslation(translations, language, "Values", title)}
        </p>
        <p
          className={classes.description}
          style={language === "ARB" ? { direction: "rtl" } : {}}
        >
          {getTranslation(
            translations,
            language,
            "Values",
            description
          )}
        </p>
        {dStarter && <Divider />}
        {dStarter && (
          <p className={classes.dStarter}>
            <DStarterContent
              content={dStarter}
              search={search}
              style={language === "ARB" ? { direction: "rtl" } : {}}
            />
          </p>
        )}
        {dStarter && <Divider />}
        <div className={classes.navButtons}>
          <div
            className={`${classes.link} ${classes.left}`}
            onClick={
              availablePassage("prev")
                ? () =>
                    search(
                      getVersionVerse(
                        versification[version],
                        availablePassage("prev").ref
                      )
                    )
                : null
            }
          >
            {availablePassage("prev") ? (
              <React.Fragment>
                <IconButton>
                  <PlayCircleFilled
                    className={classes.icon}
                    style={{ transform: "rotate(180deg)" }}
                  />
                </IconButton>
                <p className={classes.nextNum}>
                  #{+availablePassage("prev").id.split("-")[2]}
                  <br />
                  {`${getTranslation(
                    translations,
                    language,
                    "Books",
                    `abbrev_${availablePassage("prev")
                      .ref.split("-")[0]
                      .trim()}`
                  )} ${
                    isStandardVersification &&
                    availablePassage("prev").standardRef
                      ? availablePassage("prev")
                          .standardRef.substring(4)
                          .replace(":", ": ")
                          .replace(",", ", ")
                      : // .replace("-", " - ")
                        availablePassage("prev")
                          .fullRef.substring(4)
                          .replace(":", ": ")
                          .replace(",", ", ")
                    // .replace("-", " - ")
                  }`}
                </p>
              </React.Fragment>
            ) : null}
          </div>
          <div
            className={`${classes.link} ${classes.right}`}
            onClick={
              availablePassage("next")
                ? () =>
                    search(
                      getVersionVerse(
                        versification[version],
                        availablePassage("next").ref
                      )
                    )
                : null
            }
          >
            {availablePassage("next") ? (
              <React.Fragment>
                <IconButton>
                  <PlayCircleFilled className={classes.icon} />
                </IconButton>
                <p className={classes.nextNum}>
                  #{+availablePassage("next").id.split("-")[2]}
                  <br />
                  {`${getTranslation(
                    translations,
                    language,
                    "Books",
                    `abbrev_${availablePassage("next")
                      .ref.split("-")[0]
                      .trim()}`
                  )} ${
                    isStandardVersification &&
                    availablePassage("next").standardRef
                      ? availablePassage("next")
                          .standardRef.substring(4)
                          .replace(":", ": ")
                          .replace(",", ", ")
                      : // .replace("-", " - ")
                        availablePassage("next")
                          .fullRef.substring(4)
                          .replace(":", ": ")
                          .replace(",", ", ")
                    // .replace("-", " - ")
                  }`}
                </p>
              </React.Fragment>
            ) : null}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ValuesDialog
